<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-card class="lighten-4 pa-3 ml-3" dark color="#181745" style="height:100%;">
    <v-autocomplete
      :items="items"
      filled
      dark
      label="Filter by"
      v-model="country"
      background-color="purple darken-2"
      hide-details
    ></v-autocomplete>
    <div v-if="loadingData" style="text-align: center; width: 100%;" class="pb-3 mt-3">
        <v-progress-circular
              indeterminate
              color="purple"
              size="36"></v-progress-circular>
      </div>
    <div>
      <div class="mb-4 pa-2 mt-4">
        <div >
          <span class="subheading grey--text text--lighten-1 mr-1">Last Updated:</span>
          <span class="subheading grey--text text--lighten-1">{{lastupdated}}</span>
        </div>
        <div class="caption grey--text text--darken-1 mt-1">Note: Data may be incomplete for the current day</div>
      </div>
    </div>

    <div>
      <v-row>
        <v-col cols="12" sm="12" class="text-center pa-0">
          <div class="ma-3 mr-2 pa-3 mt-0" style="background-color: rgba(0,0,0,0.2);">
            <div class="subheading" style="font-weight: 300; text-transform: uppercase;">
              Confirmed
            </div>
            <div class="title mt-2 blue--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '22px !important': '28px !important', 'font-weight': '300' }">
              {{getNumberDisplay(confirmed)}}</div>
            <div v-if="confirmed_change != 0" class="mt-2 mr-3">
              <div v-if="confirmed_change > 0">
                <v-icon dark color="pink lighten-2" size="22">arrow_drop_up</v-icon>
                <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(confirmed_change))}}</span>
              </div>
              <div v-if="confirmed_change < 0">
                <v-icon dark color="green" size="22">arrow_drop_down</v-icon>
                <span class="subheading green--text" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(confirmed_change))}}</span>
              </div>            
            </div>
          </div>
        </v-col>
        <!-- <v-col cols="12" sm="6" class="text-center pa-0">
          <div class="ma-3 ml-2 pa-3 mt-0" style="background-color: rgba(0,0,0,0.2);">
            <div class="subheading" style="font-weight: 300; text-transform: uppercase;">
              Recovered
            </div>
            <div class="title mt-2 green--text" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '22px !important': '28px !important', 'font-weight': '300' }">
              {{getNumberDisplay(recovered)}}</div>
            <div v-if="recovered_change != 0" class="mt-2 mr-3">
              <div v-if="recovered_change < 0">
                <v-icon dark color="pink lighten-2" size="22">arrow_drop_down</v-icon>
                <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(recovered_change))}}</span>
              </div>
              <div v-if="recovered_change > 0">
                <v-icon dark color="green" size="22">arrow_drop_up</v-icon>
                <span class="subheading green--text" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(recovered_change))}}</span>
              </div>            
            </div>
          </div>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" class="text-center pa-0">
          <div class="ma-3 mr-2 mt-1 pa-3" style="background-color: rgba(0,0,0,0.2);">
            <div class="subheading" style="font-weight: 300; text-transform: uppercase;">
              Deaths
            </div>
            <div class="title mt-2 pink--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '22px !important': '28px !important', 'font-weight': '300' }">
              {{getNumberDisplay(deaths)}}</div>
            <div v-if="deaths_change != 0" class="mt-2 mr-3">
              <div v-if="deaths_change > 0">
                <v-icon dark color="pink lighten-2" size="22">arrow_drop_up</v-icon>
                <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(deaths_change))}}</span>
              </div>
              <div v-if="deaths_change < 0">
                <v-icon dark color="green" size="22">arrow_drop_down</v-icon>
                <span class="subheading green--text" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(deaths_change))}}</span>
              </div>            
            </div>
          </div>
        </v-col>
        <!-- <v-col cols="12" sm="6" class="text-center pa-0">
          <div class="ma-3 ml-2 mt-1 pa-3" style="background-color: rgba(0,0,0,0.2);">
            <div class="subheading" style="font-weight: 300; text-transform: uppercase;">
              Active
            </div>
            <div class="title mt-2 orange--text text--lighten-1" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '22px !important': '28px !important', 'font-weight': '300' }">
              {{getNumberDisplay(active)}}</div>
            <div v-if="active_change != 0" class="mt-2 mr-3">
              <div v-if="active_change > 0">
                <v-icon dark color="pink lighten-2" size="22">arrow_drop_up</v-icon>
                <span class="subheading pink--text text--lighten-2" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(active_change))}}</span>
              </div>
              <div v-if="active_change < 0">
                <v-icon dark color="green" size="22">arrow_drop_down</v-icon>
                <span class="subheading green--text" style="font-weight: 300;font-size: 16px !important;">{{getNumberDisplay(getChangeDisplay(active_change))}}</span>
              </div>            
            </div>
          </div>
        </v-col> -->
      </v-row>
    </div>

    <div class="mt-4 pb-5">
      <v-row>
        <!-- <v-col cols="12">
          <v-card dark flat class="pa-3" color="rgb(35, 122, 113)" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
            <div class="caption grey--text text--lighten-2">CASE RECOVERY RATE</div>
            <div class="headline mt-2">{{recovered_perc + ' %'}}</div>      
            <span class="caption mt-2">{{getNumberDisplay(recovered)}}</span>
            <span class="caption mt-2 ml-2 mr-2 grey--text text--lighten-2">of</span>
            <span class="caption mt-2">{{getNumberDisplay(confirmed)}}</span>
            <span class="caption mt-2 ml-2 grey--text text--lighten-2">cases</span>
          </v-card>
        </v-col> -->
        <v-col cols="12">
          <v-card dark flat class="pink darken-1 pa-3" v-bind:style="{ 'text-align': 'center', 'height': '100%' }">
            <div class="caption grey--text text--lighten-2">CASE FATALITY RATE</div>
            <div class="headline mt-2">{{deaths_perc + ' %'}}</div>      
            <span class="caption mt-2">{{getNumberDisplay(deaths)}}</span>
            <span class="caption mt-2 ml-2 mr-2 grey--text text--lighten-2">of</span>
            <span class="caption mt-2">{{getNumberDisplay(confirmed)}}</span>
            <span class="caption mt-2 ml-2 grey--text text--lighten-2">cases</span>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="12" sm="12">
        <div class="mt-0 pt-0">
          <div>
            <span class="caption grey--text mr-1" style="font-weight: 300;">Data Sources:</span>
            <a class="caption" href="https://covid19.who.int/" target="_blank">WHO</a>
            <span class="mr-2">&nbsp;</span>
            <a
              class="caption"
              href="https://github.com/CSSEGISandData/COVID-19"
              target="_blank"
            >JHU</a>
            <span class="mr-2">&nbsp;</span>
            <a class="caption" href="../../data/africa/sources.csv" target="_blank">other</a>
          </div>
          <div>
            <span class="caption grey--text mr-1" style="font-weight: 300;">Legal:</span>
            <a class="caption" href="./privacy.html" target="_blank">Privacy Policy</a>
            <span class="mr-2">&nbsp;</span>
            <a class="caption" href="#" @click="dialogDisclaimer = true">Disclaimer</a>
          </div>
          <div>
            <span class="caption grey--text mr-1" style="font-weight: 300;">
              © 2021
              <a href="https://awarenesscompany.co.za" target="_blank">The Awareness Company</a>
              <span class="caption grey--text ml-1">All Rights Reserved.</span>
            </span>
          </div>
        </div>
      </v-col>
      <!-- <v-col cols="12" sm="4" class="text-center">
        <div class="caption grey--text mb-2" style="font-weight: 300;">Supported By</div>
          <img
          src="../../../public/assets/4afrika.png"
          v-bind:style="{ 'height': $vuetify.breakpoint.lgAndUp? '60px': '60px', 'vertical-align': 'middle'}"
        />
      </v-col> -->
    </v-row>
    
    <v-dialog
      v-model="dialogDisclaimer"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.mdAndDown"
    >
      <v-card>
        <v-card-title class="title purple darken-1 white--text">Disclaimer</v-card-title>
        <v-card-text>
          <div class="title mt-3">21 March 2020</div>
          <div class="body-1 mt-3">
            The information contained on the www.health.hydra.africa website (the "Service") is for general information purposes only. The Awareness Company assumes no responsibility for errors or omissions in the contents on the Service.
            <br />
            <br />In no event shall The Awareness Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Awareness Company reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice.
            <br />
            <br />The www.health.hydra.africa website may contain links to external websites that are not provided or maintained by or in any way affiliated with The Awareness Company. Please note that The Awareness Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
            <br />
            <br />The www.health.hydra.africa website is not in any way affiliated with any official government or health organisations.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogDisclaimer = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

export default {
  name: "Overview",
  data: () => ({
    items: [],
    country: "Africa",
    confirmed: 0,
    confirmed_change: 0,
    recovered: 0,
    recovered_change: 0,
    recovered_perc: 0,
    deaths: 0,
    deaths_change: 0,
    deaths_perc: 0,
    active: 0,
    active_change: 0,
    lastupdated: "",
    dialogDisclaimer: false,
    loadingData: true
  }),
  watch: {
    country: function (val) {
      //emit the filter
      this.$emit("filterCountry", val)
      
      //post the GA
      gtag('event', 'filter', {
        'event_category' : val,
        'send_to': 'UA-161523063-2'
      });
    },
  },
  methods: {
    loadCountriesList(data) {
      this.items = [];

      //set the countries dropdown
      this.items.push("Africa")
      for (var i = 0; i < data.length; i++) {
        this.items.push(data[i].Country_WHO)
      }
    },
    loadCases(data, countryDisplay) {
      //clear data
      this.confirmed = 0;
      this.confirmed_change = 0;
      this.recovered = 0;
      this.recovered_change = 0;
      this.recovered_perc = 0;
      this.deaths = 0;
      this.deaths_change = 0;
      this.deaths_perc = 0;
      this.active = 0;
      this.active_change = 0;
    
      //check no data
      if (data.length === 0) {
        return;
      }

      //set the last updated
      var lastDate = data[0].cases[data[0].cases.length - 1].date
      var cdate = this.$moment(lastDate, "YYYY-MM-DD")
      this.lastupdated = cdate.format('LL')

      //loop through each country and add up the last and previous stats
      var lastConfirmed = 0
      var prevConfirmed = 0
      var lastRecovered = 0
      var prevRecovered = 0
      var lastDeaths = 0
      var prevDeaths = 0
      var lastActive = 0
      var prevActive = 0

      for (var i = 0; i < data.length; i++) {
        
        //add to totals
        lastConfirmed += data[i].cases[data[i].cases.length - 1].cumulative_cases
        prevConfirmed += data[i].cases[data[i].cases.length - 2].cumulative_cases

        lastRecovered += data[i].cases[data[i].cases.length - 1].cumulative_recovered
        prevRecovered += data[i].cases[data[i].cases.length - 2].cumulative_recovered

        lastDeaths += data[i].cases[data[i].cases.length - 1].cumulative_deaths
        prevDeaths += data[i].cases[data[i].cases.length - 2].cumulative_deaths

      }

      //calculate the active cases
      lastActive = lastConfirmed - lastRecovered - lastDeaths
      prevActive = prevConfirmed - prevRecovered - prevDeaths

      //set the data
      this.confirmed = lastConfirmed
      this.recovered = lastRecovered
      this.deaths = lastDeaths
      this.active = lastActive

      //calculate the delta
      this.confirmed_change = lastConfirmed - prevConfirmed
      this.recovered_change = lastRecovered - prevRecovered
      this.deaths_change = lastDeaths - prevDeaths
      this.active_change = lastActive - prevActive

      //calculate the percs
      var fperc = (this.deaths/this.confirmed) * 100
      this.deaths_perc = parseFloat(fperc.toFixed(0))
      if(this.deaths_perc === 0) {
        this.deaths_perc = parseFloat(fperc.toFixed(2))
      }

      var rperc = (this.recovered/this.confirmed) * 100
      this.recovered_perc = parseFloat(rperc.toFixed(0))
      if(this.recovered_perc === 0) {
        this.recovered_perc = parseFloat(rperc.toFixed(2))
      }

      this.loadingData = false

    },
    getChangeDisplay(change) {
      return Math.abs(change);
    },
    getNumberDisplay(number) {
      return number.toLocaleString("en").replace(/\,/g, " ");
    },
  },
};
</script>